export function ScrollingBanner() {
  const items = [
    "Livraison offerte dès 59€",
    "Marques authentiques garanties",
    "Retours gratuits sous 1 mois",
    "Support client 7j/7",
    "Paiement sécurisé",
  ];

  const repeated = [...items, ...items];

  return (
    <div className="overflow-hidden bg-gradient-electric border-b border-border py-3">
      <div className="animate-marquee flex whitespace-nowrap">
        {repeated.map((item, i) => (
          <span key={i} className="mx-8 text-sm font-medium text-electric-foreground flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--badge-new)] inline-block" />
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}
